import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all chadawa with filters - UPDATE THIS FUNCTION
export const getChadawas = async (params = {}) => {
  try {
    const response = await api.get(`${API_URL}/chadawa`, {
      params: params // Add this line to send query parameters

        
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this to properly handle errors
  }
};


// Add a new chadawa
export const addChadawa = async (chadawa) => {  
  try {
    const response = await api.post(`${API_URL}/chadawa`, chadawa,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};


// Update a chadawa
export const updateChadawa = async (id, chadawa) => {
  try {
    const response = await api.put(`${API_URL}/chadawa/${id}`, chadawa,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};


// Update an astrologer status
export const updateChadawaStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(`${API_URL}/chadawa/status/${id}`, updateStatusObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};


// Delete a chadawa
export const deleteChadawa = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/chadawa/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};